module.exports = __webpack_public_path__ + "static/media/21.628f346a.png";